export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Mensajes.vue?vue&type=template&id=5bce9516&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Mensajes.vue?vue&type=template&id=5bce9516&scoped=true&
// module id = 581
// module chunks = 0